/* AVS: Instanziert die Quick-Add-Templates aus product-card.liquid ERST BEI BEDARF.

   Hintergrund: enable_quick_shop war deaktiviert, weil das tief verschachtelte
   Quick-Add-Markup (Form, Mengenwahl, Buttons) pro Karte das DOM aufbläht.
   Ansatz hier: Das Markup bleibt in <template> (kein Layout-/Paint-Kosten,
   nicht im DOM-Baum, für Suchmaschinen irrelevant) und wird pro Karte erst
   bei der ersten Interaktion (Hover/Tastatur-Fokus) eingesetzt — also genau
   dann, wenn das Overlay gleich sichtbar würde. DOM-Kosten ohne Interaktion: 0.

   Event-Delegation auf document -> überlebt AJAX-Neurender (Filter, Load-More,
   Recommendations) ohne Re-Init, kein MutationObserver nötig. Mobile (<768px)
   instanziert nie (Overlay dort per Design nicht vorgesehen). */
(function () {
  var mq = window.matchMedia('(min-width: 768px)');

  function instantiate(card) {
    var tmpl = card.querySelector('template[id^="quick-add-template-"]');
    if (!tmpl) return;
    var placeholder = card.querySelector('[id^="quick-add-placeholder-"]');
    if (placeholder && !placeholder.hasChildNodes()) {
      placeholder.appendChild(tmpl.content.cloneNode(true));
    }
  }

  function onIntent(evt) {
    if (!mq.matches) return;
    var t = evt.target;
    if (!t || !t.closest) return;
    var card = t.closest('product-card');
    if (card) instantiate(card);
  }

  document.addEventListener('pointerover', onIntent, { passive: true });
  document.addEventListener('focusin', onIntent);
})();
